export default {
  googleAuthorizeTerms: "Esta aplicação vai deixar de ser suportada após 10 de março de 2023. Instale a nossa nova versão do {googleAppName}."
};

// @key: @#@"googleAuthorizeTerms"@#@ @source: @#@"This app will not be supported after Mar 10th, 2023. Please install our new version of {googleAppName}."@#@
